import React from 'react'
import { useBrandingStore } from '@/stores/branding.store'

const SIZE_CLASS = {
  sm: 'w-10 h-10',
  lg: 'w-20 h-20 sm:w-24 sm:h-24',
} as const

interface AppLogoProps {
  size?: keyof typeof SIZE_CLASS
  className?: string
}

export const AppLogo: React.FC<AppLogoProps> = ({ size = 'lg', className = '' }) => {
  const { logoUrl, appName } = useBrandingStore(state => state.branding)

  return (
    <img
      src={logoUrl}
      alt={appName}
      className={`object-contain shrink-0 rounded-xl ${SIZE_CLASS[size]} ${className}`.trim()}
    />
  )
}
